import { TypographyLogo, TypographyLogoLightIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import { ExamPhase } from '../../types';
import Webcam from 'react-webcam';
import { RefObject } from 'react';

interface Props {
    phase: ExamPhase;
    language: string;
    submitting: boolean;
    cameraAccess: boolean;
    jobTitle?: string;
    onExit: () => void;
    onSubmit: () => void;
    onCameraError: () => void;
    webcamRef: RefObject<Webcam>;
    onCameraStream: (stream: MediaStream) => void;
};

/**
 * The bar across the top of every screen. It turns dark for the exam itself, and holds
 * the camera preview that asks for permission before the exam starts.
 */
function ExamHeader(props: Props) {
    const {
        phase,
        onExit,
        language,
        jobTitle,
        onSubmit,
        webcamRef,
        submitting,
        cameraAccess,
        onCameraError,
        onCameraStream,
    } = props;

    /** A question is on screen — including while the break modal covers it. */
    const isRunning = phase === 'Question' || phase === 'Break';

    return (
        <div className={styles.header} data-is-dark={isRunning}>
            {isRunning
                ? <TypographyLogoLightIcon width={145} height={36} />
                : <TypographyLogo width={145} height={36} />}

            {phase === 'PreExam' &&
                <div className={styles.stream}>
                    <div className={styles.stream_video}>
                        {cameraAccess && <Webcam
                            audio
                            muted
                            ref={webcamRef}
                            onUserMedia={onCameraStream}
                            onUserMediaError={onCameraError}
                        />}
                    </div>
                </div>}

            {isRunning && <span className={styles.header_exam_title}>
                {language} exam for {jobTitle}
            </span>}

            <div>
                <div className={styles.header_actions}>
                    {isRunning && <Button
                        type='Primary'
                        text='Submit'
                        onClick={onSubmit}
                        loading={submitting}
                        className={styles.header_actions_btn}
                    />}
                    {(isRunning || phase === 'PreExam') && <Button
                        text='Exit exam'
                        type='Outline-Error'
                        onClick={onExit}
                        className={styles.header_actions_btn}
                    />}
                </div>
            </div>
        </div>
    )
};

export default ExamHeader;
